import { useEffect, useRef, useState } from "react"
import { isMobile } from "react-device-detect"
import { Dialog } from "tdesign-react"
import "tdesign-react/es/style/index.css" // 少量公共样式
import "./App.scss"
import { VirtualMan } from "./components/virtual_man/virtual_man"
import { useBasicStore } from "./store"
import { genSecret } from "./utils"

const urlInfo = {
  liveStat: "https://console.cloud.tencent.com/live/livestat?visible=1", // 概览页
  poster:
    "https://qcloudimg.tencent-cloud.cn/raw/5bd78e2f6eea2146886c6f542907961f.png", // 封面
  status:
    "https://qcloudimg.tencent-cloud.cn/raw/99158df20f0d2d1e70612961270ad02e.gif", // 状态图标
  goIcon:
    "https://qcloudimg.tencent-cloud.cn/raw/2e1f932f15bc00e295095adeec38a1dd.svg", // 箭头图标
  fetchUrl: "https://pullpush-virtualman.tliveapi.com/virtualman_showroom/info", // 接口地址
}
const imgInfo = {
  entrance:
    "https://qcloudimg.tencent-cloud.cn/raw/1a726b6ef32932984c3c85e19b53628c.gif",
  liveStatus:
    "https://qcloudimg.tencent-cloud.cn/raw/c6fdc6d52015f64dbabee9683b13ce7f.svg",
  onlineAudience:
    "https://qcloudimg.tencent-cloud.cn/raw/99450574b01ed6caa94098f0079ca0db.svg",
  buildOwnLiveRoom:
    "https://qcloudimg.tencent-cloud.cn/raw/e044d705656bb8b8564c054d98159a04.svg",
}

export type TypeDoc = { Link: string; Title: string; IconUrl: string }
export type TypeInfo = {
  EnableDisplay: 0 | 1
  ElvbRoomId: string | null
  BannerInfoList: {
    DefaultBannerList: TypeDoc[]
    MatchBannerList: {
      BannerList: TypeDoc[]
      KeyWord: string
    }[]
  }
  PlayUrlExtParam?: string // 拼接参数
  PlayUseProtocol?: "http" | "webrtc"
}
const initInfo: TypeInfo = {
  EnableDisplay: 0,
  ElvbRoomId: null,
  BannerInfoList: { DefaultBannerList: [], MatchBannerList: [] },
  PlayUrlExtParam: "",
}

const fetchUrl =
  "https://pullpush-virtualman.tliveapi.com/virtualman_showroom/info"

export default function App() {
  const virtualModalOuter = useRef(null)
  const [visible, setVisible] = useState(false)
  const [info, setInfo] = useState<TypeInfo>(initInfo)
  const [OnlinePlayers] = useBasicStore((state: any) => [state.OnlinePlayers])

  // 去直播概览页
  function toLive() {
    window.open(urlInfo.liveStat)
  }

  // 获取数字人信息
  function getVirtualManInfo() {
    fetch(`${fetchUrl}?${genSecret()}`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        Action: "DescribeVirtualmanShowRoomInfo",
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        setInfo(res)
      })
      .catch((err) => console.log("Request Failed", err))
  }

  function showModal() {
    window.open("https://live.monitor.qcloud.com/live-ai/", "_blank")
    // if (isMobile) {
    //   window.open(
    //     `https://txelive.com/h5/?roomid=${info.ElvbRoomId}&type=1`,
    //     "_blank",
    //   )
    // } else {
    //   setVisible(true)
    // }
  }

  // 判断是否展示【直播中】的弹窗
  function showEntrance() {
    // 调用接口查询状态
    fetch(`${urlInfo.fetchUrl}?${genSecret()}`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        Action: "DescribeVirtualmanShowRoomInfo",
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        const modal = document.getElementById(
          "virtual_modal_outer",
        ) as HTMLDivElement
        if (modal) {
          modal.style.display = res?.EnableDisplay ? "block" : "none"
        }
      })
      .catch((err) => console.log("Request Failed", err))
  }

  useEffect(() => {
    showEntrance()
    getVirtualManInfo()
  }, [])

  useEffect(() => {
    const videoWrap = document.querySelector(
      ".tpm-prod-hero__video-wrap",
    ) as HTMLElement
    if (!virtualModalOuter?.current) {
      return
    }
    videoWrap.appendChild(virtualModalOuter?.current)
  }, [virtualModalOuter])

  return (
    <div className="virtual_modal_outer" ref={virtualModalOuter}>
      {/* 弹窗部分 */}
      <Dialog
        destroyOnClose={true}
        top={100}
        visible={visible}
        cancelBtn={false}
        confirmBtn={false}
        attach={"#app-root"}
        header={
          <div className="virtual_live_modal_title">
            <div className="virtual_live_modal_title_left">
              <div className="virtual_live_status">
                <img src={imgInfo.liveStatus} alt="liveStatus" />
                <span>{"直播中"}</span>
              </div>
              <div className="online_audience">
                <img src={imgInfo.onlineAudience} alt="onlineAudience" />
                <span>{`在线观众·${OnlinePlayers}人`}</span>
              </div>
              <div className="title">{"腾讯云直播官方答疑直播间"}</div>
            </div>
          </div>
        }
        body={<VirtualMan info={info} />}
        width={1270}
        onCloseBtnClick={() => setVisible(false)}
      />

      <div id="virtual_modal" style={{ width: isMobile ? undefined : 320 }}>
        <div className="poster" onClick={() => showModal()}>
          {isMobile ? (
            <img height={144} src={urlInfo.poster} alt="poster"></img>
          ) : (
            <img width="318" src={urlInfo.poster} alt="poster"></img>
          )}
        </div>
        <div
          className="title"
          style={{ margin: isMobile ? "1px 5px" : "6px 10px" }}
        >
          <div className="img_outer" onClick={() => showModal()}>
            <img height="24" src={urlInfo.status} alt="status"></img>
            <span className="title_text">AI 体验直播间</span>
          </div>
          <img
            height="16"
            alt="go"
            onClick={() => toLive()}
            style={{ cursor: "pointer" }}
            src={urlInfo.goIcon}
          ></img>
        </div>
      </div>
    </div>
  )
}
